import { render, staticRenderFns } from "./ContainerNewsCategory.vue?vue&type=template&id=cb8e6266"
import script from "./ContainerNewsCategory.vue?vue&type=script&lang=js"
export * from "./ContainerNewsCategory.vue?vue&type=script&lang=js"
import style0 from "./ContainerNewsCategory.vue?vue&type=style&index=0&id=cb8e6266&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports